const getUploadedPhotoByIdentity = (photos, identity) => {
  if (!identity) {
    return null;
  }

  return photos.find(photo => photo.identityId === identity.id);
};

const getUploadedPhotoById = (photos = [], photoId) => {
  if (!photos.length || !photoId) {
    return null;
  }

  return photos.find(({ id }) => id === photoId);
};

const photoUploadFilter = file => {
  // For some reason, HEIC/HEIF files - at least on Windows - appear to have no type.
  // We'll just use the extension and hope the platform handles them just fine.
  const isHeicFile =
    file?.name?.toLowerCase().includes('.heic') ||
    file?.name?.toLowerCase().includes('.heif');

  return (
    (isHeicFile || (file?.type ?? '').match(/image\/(jpeg|png|heic|heif)/)) &&
    (file?.size ?? 0) > 0
  );
};

export { getUploadedPhotoByIdentity, getUploadedPhotoById, photoUploadFilter };
